import {
  ANXIETY,
  ARTERIAL_STIFFNESS,
  BLOOD_PRESSURE,
  BODY_FAT_PERCENTAGE,
  BODY_MASS_INDEX,
  C_REACTIVE_PROTEIN_I,
  CARDIORESPIRATORY_FITNESS,
  CHOLESTEROL,
  DEPRESSION,
  FRAMINGHAM_SCORE,
  HBA1C,
  HDL_CHOL,
  LDL_CHOL,
  LIPID_ACCUMULATION_PRODUCT,
  MET_S_DEGREE,
  RESTING_HEART_RATE,
  TEN_YEAR_CVD_RISK,
  TRIGLYCERIDES,
  VISCERAL_ADIPOSITY_INDEX,
  WAIST_HEIGHT_RATIO,
  WAIST_HIP_RATIO,
} from '@constants/fhir';

import anxiety from './anxiety';
import arterialStiffness from './arterial-stiffness';
import bp from './blood-pressure';
import bmi from './bmi';
import bodyFat from './body-fat';
import cardioFitness from './cardio-fitness';
import cholesterol from './cholesterol';
import crpi from './crpi';
import depression from './depression';
import framinghamScore from './framingham-score';
import hba1c from './hba1c';
import hdl from './hdl';
import lap from './lap';
import ldl from './ldl';
import metsDegree from './mets-degree';
import rhr from './resting-heart-rate';
import tenYrCvd from './ten-yr-cvd';
import triglycerides from './trglycerides';
import type { ReferenceRange } from './types';
import vai from './vai';
import waistHeight from './waist-height';
import waistHip from './waist-hip';

const referenceRanges = new Map<string, ReferenceRange<string>>([
  [BLOOD_PRESSURE, bp],
  [RESTING_HEART_RATE, rhr],
  [CARDIORESPIRATORY_FITNESS, cardioFitness],
  [ARTERIAL_STIFFNESS, arterialStiffness],
  [TEN_YEAR_CVD_RISK, tenYrCvd],
  [FRAMINGHAM_SCORE, framinghamScore],
  [BODY_MASS_INDEX, bmi],
  [WAIST_HEIGHT_RATIO, waistHeight],
  [WAIST_HIP_RATIO, waistHip],
  [BODY_FAT_PERCENTAGE, bodyFat],
  [VISCERAL_ADIPOSITY_INDEX, vai],
  [HBA1C, hba1c],
  [CHOLESTEROL, cholesterol],
  [HDL_CHOL, hdl],
  [LDL_CHOL, ldl],
  [TRIGLYCERIDES, triglycerides],
  [LIPID_ACCUMULATION_PRODUCT, lap],
  [C_REACTIVE_PROTEIN_I, crpi],
  [MET_S_DEGREE, metsDegree],
  [DEPRESSION, depression],
  [ANXIETY, anxiety],
]);

export {
  bp,
  rhr,
  cardioFitness,
  arterialStiffness,
  tenYrCvd,
  framinghamScore,
  bmi,
  waistHeight,
  waistHip,
  bodyFat,
  vai,
  hba1c,
  cholesterol,
  hdl,
  ldl,
  triglycerides,
  lap,
  crpi,
  metsDegree,
  depression,
  anxiety,
};

export default referenceRanges;
